import React from 'react';
import Header from '../../../components/header/Header';
import Footer from '../../../components/footer/Footer';
import HeroCarousel from '../../../components/carousel/HeroCarousel';
import img1 from '../../../assets/ld1.webp';
import img2 from '../../../assets/ld2.png';
import img3 from '../../../assets/ld3.png';
import Breadcrumb from '../../../shared/components/Breadcrumb';

export default function DikshaPage() {
  const carouselImages = [img1, img2, img3];
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <HeroCarousel images={carouselImages} autoRotateInterval={3000} />
      <div className="w-full max-w-7xl px-4">
              <Breadcrumb />
            </div>
      <main className="flex-grow w-full flex flex-col items-center justify-center py-12">
        <h1 className="text-3xl font-bold mb-6 text-[#F36B21]">DIKSHA - ETB & eContent</h1>
        <p className="max-w-2xl text-center text-gray-700 mb-8">
          Welcome to the DIKSHA - ETB & eContent page. Here you can find all the details and statistics about DIKSHA. (Replace this text with actual content.)
        </p>
        {/* Add more content or components as needed */}
      </main>
      <Footer />
    </div>
  );
}
